'use client'

import { ErrorFallback } from '@/components/errors/error-fallback'

export default function AppError({
  error,
  unstable_retry,
  reset,
}: {
  error: Error & { digest?: string }
  unstable_retry?: () => void
  reset?: () => void
}) {
  return <ErrorFallback error={error} unstable_retry={unstable_retry} reset={reset} area="app-root" route="/app" />
}
